import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';

export function SideFiltersSkeleton() {
  const brandSkeletonIds = Array.from({ length: 5 }, (_, i) => `brand-${i}`);
  const tagGroupIds = Array.from({ length: 3 }, (_, i) => `tag-group-${i}`);
  const tagSkeletonIds = Array.from({ length: 3 }, (_, i) => `tag-${i}`);

  return (
    <div className="sidebar flex h-full flex-col pt-0">
      <div className="mt-5 flex-1 ps-4 overflow-y-auto xl:mt-0">
        {/* Global filters */}
        <div className="mb-4 mt-1 space-y-4">
          <Skeleton className="h-12 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>

        <Separator />

        {/* Price range */}
        <div className="mb-2 mt-4">
          <Skeleton className="mb-3 h-10 w-full rounded-xl" />
          <Skeleton className="h-32 w-full rounded-lg" />
        </div>

        <Separator />

        {/* Brands */}
        <div className="mb-2 mt-4">
          <Skeleton className="mb-3 h-10 w-full rounded-xl" />
          <div className="space-y-2">
            {brandSkeletonIds.map((id) => (
              <Skeleton key={id} className="h-8 w-full rounded-lg" />
            ))}
          </div>
        </div>

        <Separator />

        {/* Tag groups */}
        {tagGroupIds.map((groupId) => (
          <div key={groupId}>
            <div className="mb-2 mt-4">
              <Skeleton className="mb-3 h-10 w-full rounded-xl" />
              <div className="space-y-2">
                {tagSkeletonIds.map((tagId) => (
                  <Skeleton key={`${groupId}-${tagId}`} className="h-8 w-full rounded-lg" />
                ))}
              </div>
            </div>
            <Separator />
          </div>
        ))}
      </div>
    </div>
  );
}
